import { v4 as uuidv4 } from 'uuid';

export class VerticalNavModel {
  public readonly id: string;
  public readonly label: string;
  public data: ObjectType<any>;
  public children: VerticalNavModel[];
  public parentId: string | undefined;
  public additionalNavs: VerticalNavModel[];
  public highlightCount?: boolean;
  public count: number | undefined;

  constructor(label: string, id?: string) {
    this.id = id || uuidv4();
    this.label = label;
  }

  public get isChild(): boolean {
    return !!this.parentId;
  }

  public get hasChildren(): boolean {
    return this.children?.length > 0;
  }

  public setChildren(childs: VerticalNavModel[]): this {
    this.children = childs;
    return this;
  }

  public setAdditionalNavs(navs: VerticalNavModel[]): this {
    this.additionalNavs = navs;
    return this;
  }

  public setData(data: ObjectType<any>): this {
    this.data = data;
    return this;
  }

  public setParentId(id: string): this {
    this.parentId = id;
    return this;
  }

  public setCount(count: number): this {
    this.count = count;
    return this;
  }

  static create(label: string, id?: string): VerticalNavModel {
    return new VerticalNavModel(label, id);
  }
}
